import MeetingSummaryConfirmation from './MeetingSummaryConfirmation';

export default MeetingSummaryConfirmation;
